module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticClass: "app-navbar"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('span', {
    on: {
      "click": _vm.toggle
    }
  }, [_c('md-icon', {
    staticClass: "toggle"
  }, [_vm._v("dehaze")])], 1), _vm._v(" "), (_vm.$route.meta.return) ? _c('router-link', {
    staticClass: "return",
    attrs: {
      "to": {
        name: _vm.link
      }
    }
  }, [_c('md-icon', [_vm._v("keyboard_backspace")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "md-title route"
  }, [_vm._v(_vm._s(_vm.$route.meta.name))])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-right"
  }, [(_vm.user.type == 'healt_provider') ? _c('div', {
    staticClass: "u-relative hidden-xs",
    on: {
      "click": function($event) {
        _vm.activeButton('notification')
      }
    }
  }, [_c('md-icon', {
    staticClass: "icon_notificatoins",
    class: {
      'active': _vm.show.notification
    }
  }, [_vm._v("\n                people_outline\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-relative hidden",
    on: {
      "click": function($event) {
        _vm.activeButton('people')
      }
    }
  }, [_c('md-icon', {
    staticClass: "icon_people",
    class: {
      'active': _vm.show.people
    }
  }, [_vm._v("\n                notifications_none\n            ")]), _vm._v(" "), _c('md-icon', {
    staticClass: "md-primary u-notification"
  }, [_vm._v("lens")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown",
    on: {
      "click": function($event) {
        _vm.activeButton('profile')
      }
    }
  }, [_c('md-avatar', {
    staticClass: "icon_avatar",
    class: {
      'active': _vm.show.profile
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar,
      "alt": "Avatar"
    }
  })]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.notification),
      expression: "show.notification"
    }],
    attrs: {
      "id": "app_notifications"
    }
  }, [(_vm.notifications.length > 0) ? _c('md-list', {
    staticClass: "custom-list md-triple-line u-block-notification"
  }, [_vm._l((_vm.notifications), function(notification, index) {
    return _c('md-list-item', {
      key: notification.id
    }, [_c('md-avatar', [_c('img', {
      attrs: {
        "src": _vm.imgNotification(notification.office.path),
        "alt": "People"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_vm._v(_vm._s(notification.user.name))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatNotification(notification.message))
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(notification.office.name) + " - " + _vm._s(_vm.difference(notification.created_at)) + ".")])]), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button md-list-action hidden"
    }, [_c('md-icon', {
      staticClass: "md-primary u-font-75 u-color-red"
    }, [_vm._v("lens")])], 1), _vm._v(" "), _c('md-divider', {
      staticClass: "md-inset"
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "divider hidden",
    staticStyle: {
      "height": "2em",
      "text-align": "center",
      "padding": ".25em 0",
      "cursor": "pointer"
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_down")])], 1)], 2) : _c('md-list', {
    staticClass: "custom-list md-triple-line u-block-notification"
  }, [_c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.translate.pages.partials.navbar.noNotifications))])])])], 1)], 1), _vm._v(" "), (_vm.show.people) ? _c('div', [_c('md-list', {
    staticClass: "custom-list md-triple-line u-block-people"
  }, [_c('md-list-item', [_c('md-avatar', [_c('img', {
    attrs: {
      "src": "https://placeimg.com/40/40/people/3",
      "alt": "People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_c('small', [_vm._v(_vm._s(_vm.translate.pages.partials.navbar.subordinate) + ": Marco Robledo")])]), _vm._v(" "), _c('span', [_vm._v("ha "), _c('strong', [_vm._v("editado")]), _vm._v(" una consulta")]), _vm._v(" "), _c('p', [_vm._v("hace 30min.")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action"
  }, [_c('md-icon', {
    staticClass: "md-primary u-font-75"
  }, [_vm._v("lens")])], 1), _vm._v(" "), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _vm._v(" "), _c('md-list-item', [_c('md-avatar', [_c('img', {
    attrs: {
      "src": "https://placeimg.com/40/40/people/4",
      "alt": "People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_c('small', [_vm._v(_vm._s(_vm.translate.pages.partials.navbar.subordinate) + ": Marco Robledo")])]), _vm._v(" "), _c('span', [_vm._v("ha "), _c('strong', [_vm._v("agregado")]), _vm._v(" una consulta")]), _vm._v(" "), _c('p', [_vm._v("+ hace 2h.")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action"
  }, [_c('md-icon', {
    staticClass: "u-font-75"
  }, [_vm._v("lens")])], 1), _vm._v(" "), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "height": "2em",
      "text-align": "center",
      "padding": ".25em 0",
      "cursor": "pointer"
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.show.profile) ? _c('div', {
    attrs: {
      "id": "app_profile"
    }
  }, [_c('md-list', {
    staticClass: "u-block-profile navbar-dropdown"
  }, [_c('md-list-item', [_c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }, [_c('span', {
    staticClass: "u-font-85 full-width user-name"
  }, [_vm._v(_vm._s(_vm.user.full_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "u-font-85 full-width"
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-list-action",
    nativeOn: {
      "click": function($event) {
        _vm.redirect($event)
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item-divider"
  }), _vm._v(" "), _c('md-list-item', {
    staticClass: "hidden"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": {
        name: 'Plans'
      }
    }
  }, [_c('span', {
    staticClass: "u-font-85"
  }, [_vm._v(_vm._s(_vm.translate.pages.partials.navbar.updatePlan))]), _vm._v(" "), _c('span', {
    staticClass: "plan_current"
  }, [_vm._v(_vm._s(_vm.translate.pages.partials.navbar.planType.basic))])])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "hidden"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "u-font-85"
  }, [_vm._v(_vm._s(_vm.translate.pages.partials.navbar.exclusivePage))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item-divider"
  }), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.hideProfile($event)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": {
        name: 'logout'
      }
    }
  }, [_c('span', {
    staticClass: "u-font-85"
  }, [_vm._v(_vm._s(_vm.translate.pages.partials.navbar.closeSession))])])], 1)], 1)], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon_caret"
  }, [_c('i', {
    staticClass: "md-icon md-list-expand-indicator md-theme-default material-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("keyboard_arrow_down")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1dee326"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/partials/Navbar.vue
// module id = 607
// module chunks = 1